import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceInRequiredValidator } from '../../../shared/constants';

@Component({
	selector: 'app-scale-create',
	templateUrl: './scale-create.component.html',
	styleUrl: './scale-create.component.css'
})
export class ScaleCreateComponent implements OnInit, AfterViewInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/scale-list",
			name: "Scales"
		}
	];
	uId: any = null;
	pagetitle = "Create Scale";
	moduleForm!: FormGroup;
	showLoader: boolean = false;
	pageLoading: boolean = false;
	details: any = null;
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) { }
	ngAfterViewInit(): void { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"] == undefined ? null : routeParams["uId"];
			this.moduleForm = this.formBuilder.group({
				scale_name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				acronym: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				description: [null, [Validators.required, noWhitespaceInRequiredValidator]]
			})
			if (this.uId) {
				this.breadcrumbList.push({ path: "/app/edit-scale/" + this.uId, name: "Edit" });
				this.pagetitle = "Edit Scale";
				this.getDetails();
			} else {
				this.breadcrumbList.push({ path: "/app/create-scale", name: "Create" });
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	formChanged() {
		this.moduleForm.markAsDirty();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getScaleDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.details = data;
				this.f.scale_name.setValue(this.details.scale_name);
				this.f.acronym.setValue(this.details.acronym);
				this.f.description.setValue(this.details.description);
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	get f() { return this.moduleForm.controls; }

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {

				}

			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let payload: any = {
			scale_name: this.f.scale_name.value,
			acronym: this.f.acronym.value,
			description: this.f.description.value
		};
		let action = "create";
		if (this.uId) {
			payload["id"] = this.uId;
			action = "edit";
		}
		this.showLoader = true;
		this.apiService.createUpdateScale(payload, action).subscribe({
			next: data => {
				this.showLoader = false;
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.gotoList();
			}, error: (error: any) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				if (error.status == 409) {
					Swal.fire({
						title: 'Already Exists',
						html: 'Scale already exists. Do you want to restore it?',
						icon: 'question',
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: 'Yes, Restore!',
						cancelButtonText: 'Cancel',
						confirmButtonColor: '#3e4fb1'
					}).then((result) => {
						if (result.value) {
							this.apiService.restoreScale(error.error.encryptid).subscribe({
								next: (data: any) => {
									this.toastr.success("Scale restored successfully", 'Success', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
									this.gotoList();
								}, error: (error) => {
									this.toastr.error("Something went wrong", 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}
							});
						} else if (result.dismiss === Swal.DismissReason.cancel) { }
					})
				} else {
					let errorMsg: any = "Something went wrong.";
					if (error.status == 400) {
						this.alreadyExistsError();
					} else {
						errorMsg = error.error;
					}
					this.toastr.error(errorMsg, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}
		});
	}

	alreadyExistsError() {
		let key = "scale_name";
		let val: any = "Already exists";
		this.moduleForm.controls[key].setErrors({ incorrect: true });
		this.customError[key] = val;
		let selector = "#" + key;
		try {
			$('html, body').animate({
				scrollTop: $(selector).offset().top - 60 + 'px'
			}, 'fast');
		} catch (error) { }
		$(selector).focus();
		return;
	}

	gotoList() {
		this.router.navigate(['/app/scale-list']);
	}
}
